module.exports = __webpack_public_path__ + "packs/media/images/lexiqamus/landing/hareket4-e521869954aee8ddafe931235ffa0738.jpg";